import { render, staticRenderFns } from "./SchoolApply.vue?vue&type=template&id=fe265116&scoped=true&"
import script from "./SchoolApply.vue?vue&type=script&lang=js&"
export * from "./SchoolApply.vue?vue&type=script&lang=js&"
import style0 from "./SchoolApply.vue?vue&type=style&index=0&id=fe265116&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe265116",
  null
  
)

export default component.exports